<script setup lang="ts">
/**
 * Translations.
 */
const { t } = useI18n()

/**
 * Use query params.
 */
const { config, options } = useParams()

/**
 * Use countries.
 */
const { isG20 } = useCountries()

/**
 * List of countries items for dropdown.
 */
const items = computed(() => {
    return options.compareCountries.filter(item => {
        return isG20(item.value)
    })
})
</script>

<template>
    <UiSelect
        v-model="config.compareCountry"
        :options="items"
        :label="t('select-country')"
        direction="top"
        autocomplete
        selectable
        class="flex-shrink-0"
        data-tutorial-step="4"
        :data-tutorial-text="t('tutorial-compare-countries')"
    />
</template>